import React, { FC, useState } from 'react';

import { IPlayer } from '../../store/user/store';

import Input from '../Input';
import List from '../Lists/List/List';
import { PX } from '../../contrib/ui';
import PlayerListItem from '../PlayerListItem/PlayerListItem';

interface IProps {
  clubId: number | string;
  containerStyle?: any;
  defaultHidden?: boolean;
  listHeight?: number;
  outlinedInput?: boolean;
  players: IPlayer[];
}

const PlayerLookup: FC<IProps> = props => {
  const { clubId, outlinedInput, containerStyle, listHeight, defaultHidden, players } = props;

  const [searchValue, setSearchValue] = useState('');

  const search = (evnt: any): void => {
    setSearchValue(evnt.target.value);
  };

  const filter = (player: IPlayer): boolean => {
    const name = `${player.firstName} ${player.lastName}`;

    return searchValue ? name.toUpperCase().includes(searchValue.toUpperCase()) : true;
  };

  return (
    <div style={containerStyle} className="player-lookup wrapper">
      <div className="padding">
        <Input
          label="PLAYER LOOKUP"
          placeholder="PLAYER LOOKUP"
          id="roster-lookup"
          fullWidth={true}
          type="search"
          onChange={search}
          outlined={outlinedInput}
        />
      </div>

      {!defaultHidden || searchValue.length > 0 ? (
        <List
          items={players}
          customFilter={filter}
          renderItem={PlayerListItem as any}
          itemHeight={50 * PX}
          listHeight={listHeight ? `${listHeight * PX}px` : ''}
          context={{ clubId }}
        />
      ) : (
        <div />
      )}
    </div>
  );
};

export default PlayerLookup;
